module.exports = __webpack_public_path__ + "img/cilinder_no_values.ea8a80b7.png";